module.exports = __webpack_public_path__ + "assets/img/detail-content-img-1-0848383a.jpg";